﻿$.fn.dxCtrlBuilderEmailStyleColonneTaille = function custom_dxCtrlBuilderEmailStyleColonneTaille(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylecolonnetaille dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleColonneTaille(this, option));
    }
    return this;
}

window.erreurTryRepaintExecuted = false
window.cdxCtrlBuilderEmailStyleColonneTaille = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty();

        var lstDxSlider = []
        var lstEleBloc = []
        option.value.find(".tdcol").each(function (idx, eleBloc) {
            lstEleBloc.push({
                idx: idx,
                eleBloc: $(eleBloc)
            })
        })
        var inLoad = true
        var inChange = false
        lstEleBloc.forEach(function (itemData, idx) {
            itemData.dxSlider = $("<div/>").appendTo(container).dxSlider({
                min: 0,
                max: 100,
                value: parseInt(itemData.eleBloc.attr("colwidthpercent")),
                onValueChanged: function (e) {
                    if (inChange || inLoad) return

                    var ajout = e.value - itemData.eleBloc.attr("colwidthpercent")
                    itemData.eleBloc.attr("colwidthpercent", e.value)

                    //on cherche sur quelle colonne envoyé la modif
                    var newLstDtModif = []
                    if (idx == lstEleBloc.length - 1) {
                        //on est sur le dernier
                        for (var i = lstEleBloc.length - 2; i >= 0; i--) { newLstDtModif.push(lstEleBloc[i]) }
                    } else {
                        for (var i = idx + 1; i < lstEleBloc.length; i++) { newLstDtModif.push(lstEleBloc[i]) }
                        for (var i = idx - 1; i >= 0; i--) { newLstDtModif.push(lstEleBloc[i]) }
                    }
                    newLstDtModif.forEach(function (itemDataModif) {
                        if (ajout > 0 && itemDataModif.eleBloc.attr("colwidthpercent") > 0) {
                            itemDataModif.eleBloc.attr("colwidthpercent", parseInt(itemDataModif.eleBloc.attr("colwidthpercent")) - ajout)
                            if (parseInt(itemDataModif.eleBloc.attr("colwidthpercent")) < 0) {
                                ajout = -parseInt(itemDataModif.eleBloc.attr("colwidthpercent"))
                                itemDataModif.eleBloc.attr("colwidthpercent", "0")
                            } else {
                                ajout = 0
                            }
                            inChange = true
                            itemDataModif.dxSlider.option("value", parseInt(itemDataModif.eleBloc.attr("colwidthpercent")))
                            itemDataModif.dxSlider.repaint()
                            inChange = false
                        } else if (ajout < 0 && itemDataModif.eleBloc.attr("colwidthpercent") < 100) {
                            itemDataModif.eleBloc.attr("colwidthpercent", parseInt(itemDataModif.eleBloc.attr("colwidthpercent")) + (-ajout))
                            if (parseInt(itemDataModif.eleBloc.attr("colwidthpercent")) > 100) {
                                ajout = parseInt(itemDataModif.eleBloc.attr("colwidthpercent")) - 100
                                itemDataModif.eleBloc.attr("colwidthpercent", "0")
                            } else {
                                ajout = 0
                            }
                            inChange = true
                            itemDataModif.dxSlider.option("value", parseInt(itemDataModif.eleBloc.attr("colwidthpercent")))
                            itemDataModif.dxSlider.repaint()
                            inChange = false
                        }
                    })

                    var txt = ""
                    lstEleBloc.forEach(function (itemDataTop) {
                        txt += ((txt.length > 0) ? "+" : "") + itemDataTop.eleBloc.attr("colwidthpercent")
                    })
                    console.log(txt)
                    option.onValueChanged()
                },
                tooltip: {
                    enabled: true,
                    format(value) {
                        return `Colonne ${idx + 1}: ${value}%`;
                    },
                    showMode: 'always',
                    position: 'bottom',
                },
                onContentReady: function (e) {
                    window.setTimeout(function () {
                        try { e.component.repaint() }
                        catch (e) {
                            if (!erreurTryRepaintExecuted) {
                                erreurTryRepaintExecuted = true
                                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                            }
                        }
                    }, 0)
                }
            }).dxSlider("instance")
        })
        inLoad = false

        $("<div style='margin-top:10px;'/>").appendTo(container).dxCtrlButton({
            text: "Egaliser les tailles des colonnes",
            onClick: function (e) {
                var width = 0
                switch (lstEleBloc.length) {
                    case 2: width = 50; break;
                    case 3: width = 33; break;
                    case 4: width = 25; break;
                    case 5: width = 20; break;
                }
                for (var i = 1; i <= lstEleBloc.length; i++) {
                    lstEleBloc[i - 1].eleBloc.attr("colwidthpercent", width)
                    if (lstEleBloc.length == 3 && i == 3) {
                        lstEleBloc[i - 1].eleBloc.attr("colwidthpercent", "34")
                    }
                }
                option.onValueChanged()
                mConstruit()
            }
        })

        container.css("height", "")
    }

    this.element = function () { return container }

    mConstruit();
}